import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BasicBackendService } from 'src/app/services/basic-backend.service';
import { User } from '../models/user.model';
import { Logout } from './auth.action';
import { AddUser, SetAddUserError, SetNewUser } from './basic.action';
import { BasicStateModel } from './basic.model';
import { StartLoading, StopLoading } from './main.action';

export const DEFAULT_STATE: BasicStateModel = {
	newUser: null,
	addUserError: null,
};

@State<BasicStateModel>({
	name: 'basic',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class BasicState {
	private basicBackend = inject(BasicBackendService);

	@Selector()
	static basicState(state: BasicStateModel): BasicStateModel {
		return state;
	}

	@Selector()
	static newUser(state: BasicStateModel): User {
		return state.newUser;
	}

	@Selector()
	static addUserError(state: BasicStateModel): string {
		return state.addUserError;
	}

	@Action(AddUser)
	addUser(ctx: StateContext<BasicStateModel>, action: AddUser) {
		ctx.dispatch([new StartLoading()]);
		ctx.patchState(DEFAULT_STATE);
		return this.basicBackend.addUser(action.user).pipe(
			tap((response) => {
				ctx.dispatch(new StopLoading());
				ctx.patchState({
					newUser: User.fromJSON(response.user),
					addUserError: null,
				});
			}),
			catchError((error) => {
				ctx.dispatch(new StopLoading());
				ctx.patchState({
					newUser: null,
					addUserError: error,
				});
				return throwError(() => error);
			})
		);
	}

	@Action(SetNewUser)
	setNewUser(ctx: StateContext<BasicStateModel>, action: SetNewUser) {
		ctx.patchState({
			newUser: action.user,
		});
	}

	@Action(SetAddUserError)
	setAddUserError(
		ctx: StateContext<BasicStateModel>,
		action: SetAddUserError
	) {
		ctx.patchState({
			addUserError: action.addUserError,
		});
	}

	@Action(Logout)
	logout(ctx: StateContext<BasicStateModel>, _action: Logout) {
		ctx.patchState(DEFAULT_STATE);
	}
}
